// extracted by mini-css-extract-plugin
module.exports = {"footer-usp-block":"FooterUspBlock_footer-usp-block__G5TZ3"};